export default {
  presets: {
    light: {
      // primary: '#FFDE5B',
      // focus: '#FFDE5B',
      backgroundPrimary: '#F4F6F8',
      backgroundSecondary: '#FFFFFF',
      backgroundCardPrimary: '#F7F9F9',
      backgroundCardSecondary: '#ECFDE6',
      backgroundBorder: '#E4F0E6',
      success: '#228200',
      info: '#158DE3',
      danger: '#E42222',
      warning: '#FFD43A',
    },
    dark: {
      // primary: '#FFDE5B',
      // focus: '#FFDE5B',
      backgroundCardPrimary: '#111827',
      backgroundCardSecondary: '#0f172a',
    },
  },
}
